/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-14T10:40:36.043
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'financial-FinancialEvidence-'

export default 
{
path: '/financial/financialevidence',
name: 'financial-FinancialEvidence',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}FinancialEvidence-index',

meta:{
...meta,
title: '实付管理'
},

component: () => import('@/pages/financial/financialevidence/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}FinancialEvidence-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '实付管理编辑'
},

component: () => import('@/pages/financial/financialevidence/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}FinancialEvidencedetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '实付管理新增'
},

component: () => import('@/pages/financial/financialevidence/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}FinancialEvidenceView',
auth: [
'hidden'
],

meta:{
...meta,
title: '实付管理详情查看'
},

component: () => import('@/pages/financial/financialevidence/detail-view') ,
},
]
};
